import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
import { NumberingConfigSchema } from './room.js';
const ItemBaseSchema = v.object({
    id: IdSchema,
    roomId: IdSchema,
    parentId: v.nullable(IdSchema),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    displayNumber: v.pipe(v.string(), v.minLength(1)),
    sortOrder: v.pipe(v.number(), v.integer(), v.minValue(0)),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema
});
export const FolderItemSchema = v.object({
    ...ItemBaseSchema.entries,
    kind: v.literal('folder'),
    numberingConfig: v.optional(v.nullable(NumberingConfigSchema)),
    directFileCount: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0)))
});
export const FileItemSchema = v.object({
    ...ItemBaseSchema.entries,
    kind: v.literal('file'),
    currentVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
    r2Key: v.pipe(v.string(), v.minLength(1)),
    mimeType: v.pipe(v.string(), v.minLength(1)),
    sizeBytes: v.pipe(v.number(), v.integer(), v.minValue(0)),
    deletedAt: v.optional(v.nullable(TimestampSchema)),
    uploadCommittedAt: v.optional(v.nullable(TimestampSchema))
});
export const ItemSchema = v.variant('kind', [FolderItemSchema, FileItemSchema]);
export const ItemsListQuerySchema = v.object({
    roomId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(100))),
    cursor: v.optional(v.pipe(v.string(), v.minLength(1)))
});
export const CreateFolderItemSchema = v.object({
    roomId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255))
});
export const MoveItemsSchema = v.object({
    itemIds: v.array(IdSchema),
    destinationFolderId: v.nullable(IdSchema)
});
//# sourceMappingURL=item.js.map